import { TextureData } from "../../../types/types";
import { ISize } from "../../../controls/scrollpane/ISize";
import { RectSize } from "../../../utils/RectSize";
import { SettingsItem } from "../options/SettingsItem";


export class RulesListItem
    extends SettingsItem
    implements ISize {
    /**
     * p | h1 | h2
     */
    public itemType: string;
    protected bgTextureData: TextureData;
    protected labelTextStyle: Phaser.Types.GameObjects.Text.TextStyle;


    public Init(
        bgTextureData: TextureData,
        labelTextStyle: Phaser.Types.GameObjects.Text.TextStyle,
        itemType: string,
    ): void {
        this.bgTextureData = bgTextureData;
        this.labelTextStyle = labelTextStyle;
        this.itemType = itemType;

        this.size = new RectSize();

        // DEBUG
        // console.log(this.itemSpacing, this.borderPadding);
        // this.itemSpacing.Set(40, 0);

        // NOTE: additional padding will be added based on type (p|h1|h2) via text style
        this.borderPadding.Set(40, 0);
    }

    public Build(): void {
        this.bg = this.scene.make.image({ x: 0, y: 0, key: this.bgTextureData.texture, frame: this.bgTextureData.frame });
        this.bg.setOrigin(0);
        this.add(this.bg);

        this.label = this.scene.make.text({ style: this.labelTextStyle });
        this.label.setOrigin(0, 0.5);
        this.add(this.label);
        // console.log("style:",this.labelTextStyle);
        // console.log(this.label.style["metrics"]);
    }

    public SetData(
        label: string = undefined,
    ): void {
        if (label != undefined) {
            this.label.text = label;
        }
    }

    public override SetWidthGetHeight(width: number): number {
        this.label.style.setWordWrapWidth(width - 2 * this.borderPadding.horizontal);

        return this.label.displayHeight + 2 * this.borderPadding.vertical;
    }

    public override OnResize(): void {
        this.bg.setDisplaySize(this.size.width, this.size.height);
        // label origin (0, 0.5)
        this.label.setPosition(this.borderPadding.horizontal, this.size.height / 2);
    }
}